import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { CmsContentListResponse } from "../models/response/CMSResponse";

export const cmsApi = {
  getPromotionByPageUrl: async (
    pageName: string
  ): Promise<UnifiedResponse<CmsContentListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<CmsContentListResponse>
    >(
      "/cms/content",
      {
        pagename: pageName,
      },
      {
        headers: {
          requiresAuth: false,
        },
      }
    );
    return response.data;
  },
};

export default cmsApi;
